import {BrandProvider} from '@constellation/core';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
import {type FC} from 'react';
import {Provider as ReduxProvider} from 'react-redux';
import {Router} from 'react-router-dom';
import {type ProviderProps} from '../types/provider.js';

const queryClient = new QueryClient();

const AppProvider: FC<ProviderProps> = ({store, theme, children, history}) => (
  <QueryClientProvider client={queryClient}>
    <ReduxProvider store={store}>
      <Router history={history}>
        <BrandProvider cssPrefix='&' theme={theme}>
          {children}
        </BrandProvider>
      </Router>
    </ReduxProvider>

    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>
);

export default AppProvider;
